import React from "react";
import { useAppInfo } from "../../../context/app";

const GetStarted = () => {
  const [app] = useAppInfo();
  const videoUrl = app?.getStarted?.video || "";
  const content = app?.getStarted?.content || "";

  // Function to handle YouTube / direct video links
  const renderVideo = (url) => {
    if (!url) return null;

    // YouTube embed
    const youtubeMatch = url.match(
      /(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]+)/
    );
    if (youtubeMatch) {
      return (
        <div className="ratio ratio-16x9 mb-3">
          <iframe
            src={`https://www.youtube.com/embed/${youtubeMatch[1]}`}
            title="Video Preview"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      );
    }

    // Generic video (mp4, etc.)
    return (
      <div className="mb-3">
        <video src={url} controls className="w-100 rounded" />
      </div>
    );
  };

  return (
    <div className="app-detail">
      {/* Hero Section */}
      <section className="bg-white py-5 border-bottom">
        <div className="container d-flex flex-column flex-md-row align-items-center text-center text-md-start gap-4">
          <img
            src={app.appImage}
            alt={app.appName}
            className="rounded shadow-sm"
            style={{ width: "120px", height: "120px" }}
          />
          <div className="flex-grow-1">
            <h2 className="fw-bold">{app.appName}</h2>
            <p className="text-muted">{app.shortDescription}</p>
            {/* <div className="d-flex gap-2 flex-wrap mb-3">
              <span className="badge bg-primary">{app.appType}</span>
              <span className="badge bg-success">{app.whoCanInstall}</span>
            </div> */}
          </div>
        </div>
      </section>

      <div className="container py-5">
        {videoUrl && (
          <div className="col-md-12">
            <div className="card shadow-sm border-0 h-100">
              <div className="ratio ratio-16x9">{renderVideo(videoUrl)}</div>
            </div>
          </div>
        )}

        {/* Description */}
        <section className="mb-5">
          <p className="">
            <div dangerouslySetInnerHTML={{ __html: content }} />
          </p>
        </section>
      </div>
    </div>
  );
};

export default GetStarted;
